import { useState, useEffect } from 'react';
import timeToPrice from 'helpers/time-to-price';
import msToHumanTime from 'helpers/ms-to-human-time';
import batteryToMiles from 'helpers/battery-to-miles';
import styles from './RideDetails.module.scss';

export default function RideDetails({ ride }) {

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().getTime());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const [, setTime ] = useState(getTime());

  function getFare() {
    return timeToPrice(ride?.duration, ride.pricingModel, ride.pricingPlan, ride.rideHold);
  }

  function getTime() {
    return msToHumanTime(ride?.duration) ?? 0;
  }

  if (!ride) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <div className={styles.value}>${getFare()}</div>
        <div className={styles.label}>Fare</div>
      </div>
      <div className={styles.item}>
        <div className={styles.value}>{ride?.time}</div>
        <div className={styles.label}>Time</div>
      </div>
      <div className={styles.item}>
        <div className={styles.value}>{batteryToMiles(ride.battery, ride.vehicleModel)} MI</div>
        <div className={styles.label}>Range</div>
      </div>
    </div>
  )
}